import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {

  consts: any = {};
  rangeValidation: any = {};
  currencies: any = {};
  data: any = {
    server: {},
    database: {},
    storage: {}
  };
  selectedServers: any = ['aws', 'none']
  setep1: any = {
    servers: [],
    databases: [],
    storages: [],
    network: 1
  };
  Environment = "Physical Server";
  setep2: any = {
    hardwareCostAssumption: [],
    dataCentCostAssumption: [],
    electricityCostAssumption: [],
    SoftwareCostAssumption: [],
    dataWareHouseAssumption: [],
    storageAssumption: [],
    itlaborcosts: [],
    networkingAssumption: [],
    dbLicenseAssumption: [],
    HardwareMaintenanceCostPercentage: 20,
    K80Cost: 5000,
    M60Cost: 6000,
    Currency: '1',
    WindowsDatacentreLicenseCost: 769.375,
    WindowsStandardLicenseCost: 121.5,
    TotalSoftwareAssuranceCost: 8665.75,
    EnterpriseSoftwareAssurancecost: 1,
    StandardSoftwareAssurancecost: 1,
    PricePerKWHour: 1,
    NumberOfRackUnitsPerRack: 1,
    DataCenterUsefulLife: 1,
    ConstructionCost: 1,
    NetworkHwSwCostPercentage: 1,
    NetworkMaintenanceCostPercentage: 20,
    ServiceProviderCostPerGB: 0.20,
    TotalHardwareSoftwareCostOverYear: 21,
    PerTapeDriveCost: 4500,
    HourlyRate: 1,
    ITAdminHour: 46.51
  };
  setep3: any = {
    Timeframe: 5,
    AWSRegins: [],
    AzureRegins: [],
    GCPRegins: [],
    IsUserDataProvied:false,
  };
  step =  1;

  constructor(
    private httpService: HttpService
  ) {
    // this.getConstValues();
    this.getCurrencies();
    this.getHardwareAssumptionValues();
    this.getSoftwareAssumptionValues();
    this.getDataWareHouseAssumptionValues();
    this.getStorageAssumptionValues();
    this.getItLaborcostsAssumptionValues();
    this.getNetworkingAssumptionValues();
    this.getDBLicenseListAssumptionValues();
    this.getAWSRegins();
    this.getAzureRegins();
    this.getGCPRegins();
  }

  getConstValues(res: any = {}): void {
    // this.httpService.get('prod/constants').subscribe((res: any) => {
    //   res.forEach((element: any) => {
    //     if (!this.consts[element.Key]) {
    //         this.consts[element.Key] = [];
    //     }
    //     this.consts[element.Key].push(element);
    //   });
    //   this.getRangeValidation();
    // });
    res.forEach((element: any) => {
      if (!this.consts[element.Key]) {
          this.consts[element.Key] = [];
      }
      this.consts[element.Key].push(element);
    });
    // this.getRangeValidation();
  }

  getHardwareAssumptionValues(): void {
    this.httpService.get('prod/physicalserverlistprices/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Min = Number(element.Min);
        element.Max = Number(element.Max);
        element.Power = Number(element.Power);
        element.Size = Number(element.Size);
        element.ServiceID = Number(element.ServiceID);
        element.Price = Number(element.Price);
        element.Cores = Number(element.Cores);
        element.ID = Number(element.ID);
        element.Procs = Number(element.Procs);
        this.setep2.hardwareCostAssumption.push(element);
        this.setep2.dataCentCostAssumption.push(element);
        this.setep2.electricityCostAssumption.push(element);
      });
    });
  }

  getSoftwareAssumptionValues(): void {
    this.httpService.get('prod/softwarecostassumptions/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.SoftwareCostAssumption = res;
    });
  }

  getDataWareHouseAssumptionValues(): void {
    this.httpService.get('prod/datawarehousecostassumption/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.dataWareHouseAssumption = res;
    });
  }

  getItLaborcostsAssumptionValues(): void {
    this.httpService.get('prod/itlaborcosts/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.itlaborcosts = res;
    });
  }

  getStorageAssumptionValues(): void {
    this.httpService.get('prod/storagecostassumption').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.storageAssumption = res;
    });
  }

  getNetworkingAssumptionValues(): void {
    this.httpService.get('prod/networkassumptions/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Value = element.Value.replace('$', '').replace('%', '')
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.networkingAssumption = res;
    });
  }

  getDBLicenseListAssumptionValues(): void {
    this.httpService.get('prod/dblicenselist/All').subscribe((res: any) => {
      res.forEach((element: any) => {
        element.Value = element.Value.replace('$', '').replace('%', '')
        element.Min = Number(element.Min);
        element.ValueString = Number(element.ValueString);
        element.Max = Number(element.Max);
        element.ServiceID = Number(element.ServiceID);
        element.TCOVersion = Number(element.TCOVersion);
        element.ID = Number(element.ID);
        element.Value = Number(element.Value);
      });
      this.setep2.dbLicenseAssumption = res;
    });
  }

  getAWSRegins(): void {
    this.httpService.get('prod/regions').subscribe((res: any) => {
      this.setep3.AWSRegins = res;
    });
  }

  getAzureRegins(): void {
    this.httpService.get('prod/azureregions').subscribe((res: any) => {
      this.setep3.AzureRegins = res;
    });
  }

  getGCPRegins(): void {
    this.httpService.get('prod/gcpregions').subscribe((res: any) => {
      this.setep3.GCPRegins = res;
    });
  }

  getRangeValidation(res: any = {}): void {
    // this.httpService.get('prod/rangevalidation').subscribe((res: any) => {
    res.forEach((element: any) => {
      this.rangeValidation[element.Key] = element;
    });
    this.rangeValidation.AverageRam.Max = 8;
    this.data.server = {
      workload: this.consts.workload,
      Environment: this.consts.Environment,
      OS: this.consts.OS,
      license: this.consts.license,
      utilizationType: this.consts.UtilizationType,
      serversNumber: this.rangeValidation.NumberOfServers,
      NoOfProcs: _.orderBy(this.consts.NoOfProcs, ['Value'], ['asc']),
      NoOfCores: _.orderBy(this.consts.NoOfCores, ['Value'], ['asc']),
      ram: this.rangeValidation.AverageRam,
      optimizedBy: this.consts.OptimizedBy,
      GPU: this.consts.GPU,
      NumberOfVms: this.rangeValidation.NumberOfVms,
      Hypervisor: this.consts.Hypervisor,
    };

    this.data.database = {
      database: this.consts.database,
      Hypervisor: this.consts.Hypervisor,
      Environment: this.consts.Environment,
      OS: this.consts.OS,
      license: this.consts.license,
      utilizationType: this.consts.UtilizationType,
      serversNumber: this.rangeValidation.NumberOfServers,
      NumberOfVms: this.rangeValidation.NumberOfVms,
      NoOfProcs: _.orderBy(this.consts.NoOfProcs, ['Value'], ['asc']),
      NoOfCores: _.orderBy(this.consts.NoOfCores, ['Value'], ['asc']),
      ram: this.rangeValidation.AverageRam,
      sqlstorage: this.rangeValidation.sqlstorage,
      optimizedBy: this.consts.OptimizedBy,
      GPU: this.consts.GPU,
      service: this.consts.service,
      servicetier: this.consts.servicetier,
      purchasemodel: this.consts.purchasemodel,
      instancecores: this.consts.instancecores,
      DBEngine: this.consts.DBEngine,
    };

    this.data.storage = {
      DiskType: this.consts.DiskType,
      Storage: this.consts.Storage,
      Capacity: this.rangeValidation.Capacity,
      BackUp: this.rangeValidation.BackUp,
      Archive: this.rangeValidation.Archive,
      Accessibility: this.rangeValidation.Accessibility,
      MaxIops: this.rangeValidation.MaxIops
    };

    // console.log(this.consts);
    // console.log(this.rangeValidation);
    // });
  }

  getCurrencies(): void {
    this.httpService.get('prod/currencies').subscribe((res: any) => {
      this.currencies = res;
    });
  }
}
